<div class="card mb-4 mx-0 mx-sm-4">
  <div class="card-body pb-0" [class.placeholder-glow]="isLoading()">
    <div class="d-flex flex-column flex-lg-row align-items-center">
      <div class="text-center text-lg-start mb-4 mb-lg-0">
        <ms-avatar
          entityType="organization"
          [identity]="avatarIdentity()"
          [showUploadControls]="true"
          [isLoading]="isLoading()"
          [imageMaxWidthPx]="200"
          (avatarChanged)="onAvatarChanged($event)"
          (avatarRemoved)="onAvatarRemoved()">
        </ms-avatar>
      </div>

      <div class="flex-grow-1 ms-lg-4 text-center text-lg-start w-100 w-lg-auto min-w-0">
        <div class="d-flex flex-column flex-lg-row align-items-center align-items-lg-start justify-content-between">
          <div class="mb-3 mb-lg-0 me-lg-3 min-w-0 w-100">
            @if (isLoading()) {
              <div class="placeholder col-8 mb-2"></div>
              <div class="placeholder col-6"></div>
            } @else {
              <h2 class="fw-bold mb-1 text-truncate min-w-0" [msTooltip]="organization()?.name ?? ''" msTooltipOnlyIfTruncated>
                {{organization()?.name}}
              </h2>

              <div class="w-fit profile-info-mw text-start mx-auto mx-lg-0">
                <ng-container *ifHasPermission="{ requiredPermissions: [OrganizationPermission.Read], organizationId: organization()?.organizationId }">
                  @if (organizationSettings()?.slug) {
                    <div class="d-flex align-items-center mb-2 min-w-0">
                      <fa-duotone-icon icon="link" class="me-2 flex-shrink-0" secondaryOpacity="0.5"></fa-duotone-icon>
                      <span class="text-muted text-truncate min-w-0"
                            [msTooltip]="organizationSettings()?.slug ?? ''" msTooltipOnlyIfTruncated>
                        {{organizationSettings()?.slug}}
                      </span>
                    </div>
                  }

                  @if (organizationSettings()?.replyToEmailAddress) {
                    <div class="d-flex align-items-center mb-2 min-w-0">
                      <fa-duotone-icon icon="envelope" class="me-2 flex-shrink-0" secondaryOpacity="0.5"></fa-duotone-icon>
                      <span class="text-truncate min-w-0"
                            [msTooltip]="organizationSettings()?.replyToEmailAddress ?? ''" msTooltipOnlyIfTruncated>
                        {{organizationSettings()?.replyToEmailAddress}}
                      </span>
                    </div>
                  }
                </ng-container>

                <div class="d-flex align-items-center mb-2 min-w-0">
                  <fa-duotone-icon icon="users" class="me-2 flex-shrink-0" secondaryOpacity="0.5"></fa-duotone-icon>
                  <span class="text-truncate min-w-0">
                    {{ (organization()?.memberCount || 0) | number }} Members
                  </span>
                </div>
              </div>
            }
          </div>

          <div class="dropdown flex-shrink-0" ifHasChildPermission>
            <button class="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown" [class.placeholder]="isLoading()"
              [disabled]="organization()?.status === OrganizationStatuses.Deleted">
              <span>Actions</span>
            </button>
            <ul class="dropdown-menu dropdown-menu-end">
              @if (organization()?.status === OrganizationStatuses.Inactive) {
                <li *ifHasPermission="{ requiredPermissions: [OrganizationPermission.Status] }">
                  <a class="dropdown-item" (click)="openActivationConfirmationModal()">
                    <fa-duotone-icon icon="power-off" secondaryOpacity="0.9" class="me-2" />{{ OrganizationsMessagingConstants.ORGANIZATIONS_REACTIVATE_ACTION_LABEL() }}
                  </a>
                </li>
              } @else if (organization()?.status === OrganizationStatuses.Active) {
                <li *ifHasPermission="{ requiredPermissions: [OrganizationPermission.Status] }">
                  <a class="dropdown-item" (click)="openActivationConfirmationModal()">
                    <fa-duotone-icon icon="ban" secondaryOpacity="0.9" class="me-2" />{{ OrganizationsMessagingConstants.ORGANIZATIONS_DEACTIVATE_ACTION_LABEL() }}
                  </a>
                </li>
              }
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="profile-nav-container mt-4">
    <ms-responsive-tabs [navItems]="navItems() ?? []" (tabChanged)="onTabClick($event)" />
  </div>
</div>

<ms-confirmation-modal #organizationProfileHeaderConfirmationModalRef
    modalId="organizationProfileHeaderConfirmationModal"
    [(isSubmitting)]="isSubmitting"
    (confirmed)="confirmationConfirmFunction($event)"
    (cancelled)="confirmationCancelFunction()"
/>

<ms-info-modal #organizationProfileHeaderInfoModalRef 
    modalId="organizationProfileHeaderInfoModal" 
/>
